module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAQCAYAAAD52jQlAAAACXBIWXMAAAsSAAALEgHS3X78AAAA2UlEQVQ4je2UL2/CUBTFf5e+lbYCwp+EBIkoggQ7PcGXgX0TJAHHV0DhEKi5mdWtCYi5iUGyLn1AXujEDI+kGCZ7zE3OPfd33ZFBfz4WkRHgc6F2DzqPGXlqLhdUX9bXthaRqRKRYcXv+mVVs7b90OFp4ORCJX6D6NXyEmP8D62HCgg81SBw21agVVeEnYdcqK7XOLqu/ehvBKXcqztUQAtoAf1PKSA9mK8g42wtPncO8fZGoez2cDpZXmIMQKrOWTb71u/PgHcZiGL4Wd2ovnhDNUmu7VREJr8sFzgizeJ+egAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/components/LangSelector/flag-fr.png
// module id = 2272
// module chunks = 1